import { SettlementAccountStatus } from "types/stripe";
import { CreateColumnCounterpartyInput } from "types/column";
import { onboardMerchant } from "utils/AxiosUtil";

// Onboard the merchant on Column: send the bank counterparty details through the
// unified onboard endpoint and return the resulting settlement-account status.
// The backend creates the counterparty, persists it + the platform on the
// merchant, so payouts are enabled once this resolves.
async function createCounterparty(
  merchantId: string,
  input: CreateColumnCounterpartyInput,
): Promise<SettlementAccountStatus> {
  const res = await onboardMerchant(merchantId, {
    counterparty: {
      name: input.name,
      routingNumber: input.routingNumber,
      accountNumber: input.accountNumber,
      accountType: input.accountType,
      legalId: input.legalId || undefined,
      address: {
        line_1: input.addressLine1,
        city: input.city,
        state: input.state || undefined,
        postal_code: input.postalCode || undefined,
        country_code: input.country,
      },
    },
  });
  return res.data;
}

const column_services = {
  createCounterparty,
};

export default column_services;
